import { AU_STATES } from 'constants/uiConstants';

const AU_TIMEZONE_BY_STATE: Record<string, string> = {
  ACT: 'Australia/Sydney',
  NSW: 'Australia/Sydney',
  VIC: 'Australia/Sydney',
  TAS: 'Australia/Sydney',
  QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  NT: 'Australia/Darwin',
  WA: 'Australia/Perth',
};

const isKnownAustralianState = (value?: string): value is string => {
  if (!value) return false;
  return AU_STATES.some((state) => state.value === value);
};

export const resolveUserTimeZone = (
  state?: string,
  country?: string
): string | undefined => {
  const normalizedCountry = country?.trim().toLowerCase();
  const normalizedState = state?.trim().toUpperCase();

  if (normalizedCountry?.includes('australia')) {
    if (isKnownAustralianState(normalizedState)) {
      return AU_TIMEZONE_BY_STATE[normalizedState];
    }
    return 'Australia/Sydney';
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

export default resolveUserTimeZone;
